import { render } from "./KSClusterTour.vue?vue&type=template&id=2ab11143"
import script from "./KSClusterTour.vue?vue&type=script&lang=js"
export * from "./KSClusterTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__